export default [
    {
        path: '/equipments',
        name: 'Company / Equipments',
        component: () => import('@/views/pages/equipments'),
        meta:
        {
            page: 'list',
        },
        children:
        [
            {
                path: ':code',
                name: 'Company / View Equipment',
                component: () => import('@/views/pages/equipments'),
                meta:
                {
                    page: 'view',
                },
            },
        ],
    },
];